import { view } from '@yola/ws-sdk';
import store from '../../../store';

const isSelectedElement = (element) => {
  const state = store.getState();
  const selectedElementId = view.selectors.getSelectedElement(state);
  const elementId = view.accessors.getLiveElementId(element);

  return elementId === selectedElementId;
};

export default isSelectedElement;
